import styled from 'styled-components'
import { CardWrapper } from '../CardSection/styles'
import { Wrapper } from '../../components/PageBuilderSection/styles'

interface Props {
  $gridColums: string
}

export const GridWrapper = styled.div<Props>`
  position: relative;
  margin-left: auto;
  margin-right: auto;
  max-width: 1920px;

  display: grid;
  grid-template-columns: ${({ $gridColums }) => $gridColums || '1fr'};
  grid-gap: 35px;
  justify-items: stretch;
  align-items: stretch;

  ${Wrapper} {
    height: 100%;
  }

  ${CardWrapper} {
    padding-bottom: calc(9 / 14 * 100%);
    aspect-ratio: unset;
  }

  ${({ theme }) => '@media ' + theme.mediaQueries.mobile} {
    grid-template-columns: 1fr;
    grid-gap: 20px;
  }
`
